import { Col, Row } from 'react-bootstrap'
import { IntegrationServiceId } from '../../../../../../../common/integrations'
import { OutboundFieldMapping } from '../OutboundFieldMapping'
import { useMemo } from 'react'
import { MentionData } from '../../../../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/Nodes/MentionNode/MentionNode'
import { ContactLinking } from '../../ContactLinking/ContactLinking'

interface CustomTaskAdminSettingsProps {
  serviceId: IntegrationServiceId
  formKey?: number
  onChange?: () => void
}

export const CustomTaskAdminSettings: React.FC<CustomTaskAdminSettingsProps> = ({ serviceId, formKey = 0, onChange }) => {
  const taskFieldMappingInputTokenOptions: MentionData[] = useMemo(() => {
    return [
      { id: 'taskId', label: 'Task Id', metadata: { type: 'string' } },
      { id: 'taskStatus', label: 'Task Status', metadata: { type: 'string' } },
      { id: 'taskPriority', label: 'Task Priority', metadata: { type: 'string' } },
      { id: 'taskDueDate', label: 'Task Due Date', metadata: { type: 'date' } },
      { id: 'taskAssignedTo', label: 'Task Assigned To', metadata: { type: 'string' } },
      { id: 'taskDescription', label: 'Task Description', metadata: { type: 'string' } },
      { id: 'Task', label: 'Title', metadata: { type: 'string' } },
      { id: 'utcNow', label: 'UTC Now', metadata: { type: 'datetime' } },
      { id: 'roomId', label: 'Room Id', metadata: { type: 'string' } },
      { id: 'sessionId', label: 'Session Id', metadata: { type: 'string' } },
    ]
  }, [])

  return (
    <>
      <Row className='mt-7'>
        <Col>
          <OutboundFieldMapping
            serviceId={serviceId}
            mappingKey='task'
            key={formKey}
            isUpdatable={false}
            inputTokenOptions={taskFieldMappingInputTokenOptions}
            onChange={onChange}
          />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <ContactLinking key={formKey} serviceId={serviceId} zocksObjectName={'Task'} mappingPath='mappings.task' onChange={onChange} />
        </Col>
      </Row>
    </>
  )
}
